import React, { useState, useEffect } from "react";
import {
  Button,
  TextField,
  Box,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControl,
  FormLabel,
  Select,
  MenuItem,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { fetchService, createService, updateService } from "../../redux/Slice/serviceslice";
import { setLoading } from "../../redux/Slice/loaderSlice";
import { toast } from "sonner";
import PersonAddAlt1Icon from "@mui/icons-material/PersonAddAlt1";
import CustomTable from "../../components/table/Table";
import { Link, useNavigate } from "react-router-dom";
import CreateService from "./CreateService";

const columns = [
  { id: 'servNo', label: 'Service No', minWidth: 50, align:'start' },
  { id: 'service_name', label: 'Service Name', minWidth: 150, align:'start' },
  { id: "status", label: "Status", minWidth: 150, align: "center" },
  { id: 'action', label: 'Action', minWidth: 100, align:'center', actionType: [{edit: true, view: true}] },
];

export const Services = () => {
  const dispatch = useDispatch();
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const navigate = useNavigate();

  const { services, totalCount } = useSelector((state) => state.service);

  const transformService = (services) => {
    if (!Array.isArray(services)) {
      console.warn("Expected 'services' to be an array, but received:", services);
      return []; 
    }
  
    return services.map((service) => ({
      _id: service._id,
      servNo: service.serv_id,
      service_name: service.name || "N/A",
      status: !!service.status, 
      action: "",
    }));
  };

  const modifiedRows = services ? transformService(services) : [];

 useEffect(() => {
    // dispatch(setLoading(true));
    dispatch(fetchService({ page, limit: rowsPerPage, searchTerm }))
      // .then(() => {
      //   dispatch(setLoading(false));
      // })
      // .catch(() => {
      //   dispatch(setLoading(false));
      // });
  }, [dispatch, page, rowsPerPage, searchTerm]);



  const handleStatusChange = (row) => {
    const updatedStatus = !row.status;
    const serviceId = row._id;
    console.log("update Status:",updatedStatus);
    console.log("ServiceId:",row._id);
    
    
    dispatch(setLoading(true));
  
    dispatch(updateService({ id: serviceId, formData: { status: updatedStatus } }))
      .unwrap()
      .then(() => {
        dispatch(setLoading(false));
      })
      .catch((error) => {
        console.error("Failed to update status:", error);
        toast.error("Failed to update status. Please try again.");
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };
  

  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
    setPage(1);
  };

  const handleView = (row) =>{
    navigate(`view-service/${row._id}`);
    }

  const handleEdit = (row) => {
    if (row._id) {
      navigate(`edit-service/${row._id}`);
    } else {
      console.log("No Service ID found for this row", row);
    }
  };

  return (
    <div className="content">
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography variant="h5" sx={{ mb: 3, mt: 3 }}>
          Services <Typography component="span">({services.length})</Typography>
        </Typography>

        <Box sx={{ display: "flex", alignItems: "center" }}>
          <TextField size="small" placeholder="Search by Service" value={searchTerm} onChange={handleSearch} fullWidth />
          <CreateService/>
        </Box>
      </Box>

      <CustomTable
        columns={columns}
        rows={modifiedRows}
        page={page}
        setPage={setPage}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        totalCount={totalCount}
        handleEdit={handleEdit}
        handleView={handleView}
        handleStatusChange={handleStatusChange}
      />

    </div>
  );
};
